import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c2fec994"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hd-epic-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_epic_content_splash = _resolveComponent("epic-content-splash")!
  const _component_epic_content_timeline = _resolveComponent("epic-content-timeline")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.screen === 'splash')
      ? (_openBlock(), _createBlock(_component_epic_content_splash, { key: 0 }))
      : (_openBlock(), _createBlock(_component_epic_content_timeline, { key: 1 }))
  ]))
}